const rua = {
  ruax: {
    accents: [{
        original: '\u0386\u0399',
        convert: '\u0391\u03aa'
      },
      {
        original: '\u0386\u03a5',
        convert: '\u0391\u03ab'
      },
      {
        original: '\u0388\u0399',
        convert: '\u0395\u03aa'
      },
      {
        original: '\u038c\u0399',
        convert: '\u039f\u03aa'
      },
      {
        original: '\u0388\u03a5',
        convert: '\u0395\u03ab'
      },
      {
        original: '\u038c\u03a5',
        convert: '\u039f\u03ab'
      },
      {
        original: '\u03ac\u03b9',
        convert: '\u03b1\u03ca'
      },
      {
        original: '\u03ad\u03b9',
        convert: '\u03b5\u03ca'
      },
      {
        original: '\u0386\u03c5',
        convert: '\u03b1\u03cb'
      },
      {
        original: '\u03ac\u03c5',
        convert: '\u03b1\u03cb'
      },
      {
        original: '\u03cc\u03b9',
        convert: '\u03bf\u03ca'
      },
      {
        original: '\u0388\u03c5',
        convert: '\u03b5\u03cb'
      },
      {
        original: '\u03ad\u03c5',
        convert: '\u03b5\u03cb'
      },
      {
        original: '\u03cc\u03c5',
        convert: '\u03bf\u03cb'
      },
      {
        original: '\u038c\u03c5',
        convert: '\u03bf\u03cb'
      },
      {
        original: '\u0386',
        convert: '\u0391'
      },
      {
        original: '\u03ac',
        convert: '\u03b1'
      },
      {
        original: '\u0388',
        convert: '\u0395'
      },
      {
        original: '\u03ad',
        convert: '\u03b5'
      },
      {
        original: '\u0389',
        convert: '\u0397'
      },
      {
        original: '\u03ae',
        convert: '\u03b7'
      },
      {
        original: '\u038a',
        convert: '\u0399'
      },
      {
        original: '\u03aa',
        convert: '\u0399'
      },
      {
        original: '\u03af',
        convert: '\u03b9'
      },
      {
        original: '\u0390',
        convert: '\u03ca'
      },
      {
        original: '\u038c',
        convert: '\u039f'
      },
      {
        original: '\u03cc',
        convert: '\u03bf'
      },
      {
        original: '\u038e',
        convert: '\u03a5'
      },
      {
        original: '\u03cd',
        convert: '\u03c5'
      },
      {
        original: '\u03b0',
        convert: '\u03cb'
      },
      {
        original: '\u038f',
        convert: '\u03a9'
      },
      {
        original: '\u03ce',
        convert: '\u03c9'
      }
    ],
    selectors: '.text-uppercase',
    selAction: 'include'
  },
  init() {
    const accents = this.ruax.accents

    // Test if a string is empty or contain only blank space.
    String.prototype.isEmpty = function() {
      return this.length === 0 || !this.trim()
    }

    for (const entry of this.getSelectorsList()) {
      let text = entry.tagName && entry.tagName.toLowerCase() === 'input' ? entry.value : entry.innerHTML
      accents.forEach(function(item) {
        const reg = new RegExp(item.original, 'g')
        text = text.replace(reg, item.convert)
      })
      entry.innerHTML = text
    }
  },
  // Get the selectors' list.
  getSelectorsList() {
    const cssProp = 'text-transform'
    const cssValue = 'uppercase'
    const manuallySetSelectors = this.ruax.selectors
    const action = this.ruax.selAction
    let selectors = this.findUppercaseSelectors()

    if ('exclude' === action && false === manuallySetSelectors.isEmpty()) {
      selectors = this.withoutExcludedSelectors(manuallySetSelectors)
    } else if (false === manuallySetSelectors.isEmpty()) {
      selectors = manuallySetSelectors
    }

    const selectorsArr = document.querySelectorAll(selectors)
    const l = selectorsArr.length

    let i,
      results = []
    for (i = 0; i < l; i++) {
      // Test whether the element is really text-transform:uppercase;
      if (window.getComputedStyle(selectorsArr[i], null).getPropertyValue(cssProp) === cssValue) {
        results.push(selectorsArr[i])
      }
    }
    return results
  },

  // Exclude specific selectors
  withoutExcludedSelectors(manuallySet) {
    const excludesArr = manuallySet.split(',')
    let withoutExcludes = this.findUppercaseSelectors()
      .split(',')
      .map(function(item) {
        return item.trim()
      })
    for (const selector of excludesArr) {
      const trimmed = selector.trim()
      if (withoutExcludes.includes(trimmed)) {
        withoutExcludes = withoutExcludes.filter(function(e) {
          return e !== trimmed
        })
      }
    }
    return withoutExcludes.join(',')
  },

  // Find all CSS selectors that use text-transform:uppercase.
  findUppercaseSelectors() {
    const loc = new URL(window.location, location)
    let variations = ['[style*="text-transform:uppercase"],[style*="text-transform: uppercase"]']
    const searchFor = /\btext-transform:\s*uppercase;/
    const styles = document.styleSheets
    let i, j, l, rules, rule

    for (i = 0; i < styles.length; i++) {
      const url = new URL(styles[i].href, location)
      if (url.origin === loc.origin) {
        rules = styles[i].cssRules
        l = rules.length
        for (j = 0; j < l; j++) {
          rule = rules[j]
          if (searchFor.test(rule.cssText)) {
            variations.push(rule.selectorText)
          }
        }
      }
    }
    let selectors = variations.filter(function(el) {
      // Clear empty and undefined.
      return el != null
    })
    return selectors.join(',')
  }
}

export default rua
